import React from 'react';
import HeaderSocials from '../header/HeaderSocials';
import "./footer.css";

const Footer = () => {
  return (
    <footer>
      <a href='#' className='footer_logo'></a>
      <ul className='permalinks'>
        <li><a href='#'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#skills'>Skills</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#education'>Education</a></li>
        <li><a href='#projects'>Projects</a></li>
        <li><a href='#contact'>Contact</a></li>
      </ul>
      <div>
        <HeaderSocials/>
      </div>
      <div className='footer_copyright'>
      <small>
        &copy;Copyright. All rights reserved 2022
      </small>
      </div>
    </footer>

  )
}

export default Footer